// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.translation-notification-container {
  padding: 24px;
  margin-bottom: 80px; /* Increased to accommodate 40px spacing from footer */
  margin-top: -35px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 224px); /* Adjusted for increased bottom margin */
}

.translation-notification-title {
  margin-bottom: 16px;
  color: #666;
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
}

/* Input container spacing */
.translation-notification-inputs {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  margin-top: 24px;
}

/* Base input styles */
.translation-notification-input {
  background-color: white;
  min-width: 240px !important; /* Increased minimum width to accommodate longer labels */
}

/* Input field styling */
.translation-notification-input .MuiOutlinedInput-root {
  border-radius: 8px;
  height: 56px !important;
}

/* Label default position with adjusted space for calendar icon */
.translation-notification-input .MuiInputLabel-root {
  transform: translate(14px, 16px) scale(1) !important;
  line-height: 1 !important;
  max-width: calc(100% - 40px) !important; /* Reduced width to accommodate calendar icon */
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding-right: 32px !important; /* Add padding to prevent overlap with calendar icon */
}

/* Label focused/filled position */
.translation-notification-input .MuiInputLabel-shrink {
  transform: translate(14px, -12px) scale(0.75) !important;
  background-color: white !important;
  padding: 0 8px !important;
  margin-top: 4px !important;
  max-width: calc(133% - 40px) !important; /* Adjusted for shrunk state */
}

/* Calendar icon positioning with increased spacing */
.translation-notification-input .MuiInputAdornment-root {
  margin-right: 12px !important;
  position: absolute !important;
  right: 0 !important;
  z-index: 1 !important; /* Ensure calendar icon stays on top */
}

/* Input text spacing */
.translation-notification-input .MuiOutlinedInput-input {
  padding-right: 40px !important; /* Adjusted padding for calendar icon */
}

/* Table container styles */
.translation-notification-table {
  max-height: calc(100vh - 400px) !important;
  overflow: auto !important;
  position: relative !important;
  border: 1px solid #E0E0E0;
}

/* Fix header position */
.translation-notification-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
  background-color: #112A63 !important;
}

.translation-notification-header-cell {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
  background-color: #112A63 !important;
  color: white !important;
  padding: 8px !important;
  vertical-align: middle !important;
  border-right: 1px solid #ffffff !important;
}

/* Table body styles */
.translation-notification-table .MuiTableBody-root {
  position: relative !important;
}

/* Hide horizontal scrollbar when not needed */
.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Sticky header styles */
.translation-notification-table .MuiTableHead-root {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
  background-color: #112A63 !important;
}

/* Visual separation for the header */
.translation-notification-header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1099;
}

/* Ensure table body scrolls properly */
.translation-notification-table .MuiTableBody-root {
  position: relative;
}

/* Scrollbar styling */
.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  display: block !important;
}

.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.translation-notification-table .MuiTableCell-root {
  border: 1px solid #E0E0E0;
  padding: 12px;
}

/* Ensure header stays on top */
.translation-notification-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 2 !important;
  background-color: #112A63 !important;
}

/* Update header cell styles */
.translation-notification-header-cell:last-child {
  border-right: none !important;
}

.translation-notification-header-cell:nth-child(2),
.translation-notification-header-cell:nth-child(3) {
  min-width: 250px !important;
  max-width: 250px !important;
}

/* Update the width for first column in header */
.translation-notification-header-cell:first-child {
  min-width: 165px !important;
  max-width: 165px !important;
}

/* Header checkbox container */
.translation-notification-header-checkbox-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1px !important;
  white-space: nowrap !important;
}

/* Header checkbox styles */
.translation-notification-header-checkbox {
  margin: 0;
  padding: 0 !important;
}

/* Match row checkbox styling with grey border */
.translation-notification-header-checkbox .MuiSvgIcon-root {
  border: 1px solid #E0E0E0 !important;
  border-radius: 4px !important;
  width: 16px !important;
  height: 16px !important;
  padding: 0 !important;
  color: white !important;
  /* Make the unchecked icon white */
}

.translation-notification-header-checkbox.Mui-checked .MuiSvgIcon-root {
  background-color: white !important;
  color: #2196f3 !important;
}

/* Remove hover and ripple effects */
.translation-notification-header-checkbox:hover {
  background-color: transparent !important;
  outline: none !important;
}

.translation-notification-header-checkbox .MuiTouchRipple-root {
  display: none !important;
}

/* Override any Material-UI default borders */
.translation-notification-header-checkbox .MuiIconButton-root {
  border: none !important;
}

.translation-notification-row {
  height: 60px;
}

.translation-notification-row:nth-of-type(even) {
  background-color: #F8F9FA;
}

/* Update cell widths and text wrapping */
.translation-notification-cell {
  padding: 12px !important;
  vertical-align: top !important;
  word-wrap: break-word !important;
  white-space: normal !important;
  max-width: 250px !important;
}

/* Remove truncation for Original Text and Added/Updated Text columns */
.translation-notification-cell:nth-child(2),
.translation-notification-cell:nth-child(3) {
  white-space: pre-wrap !important;
  min-width: 250px !important;
  max-width: 250px !important;
}

/* Keep truncation for other columns */
.translation-notification-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Remove truncation for specific columns */
.translation-notification-cell:nth-child(2) .translation-notification-truncate,
.translation-notification-cell:nth-child(3) .translation-notification-truncate {
  white-space: pre-wrap !important;
  word-break: break-word !important;
}

/* Adjust width for text columns */
.translation-notification-cell:nth-child(2),
.translation-notification-cell:nth-child(3) {
  min-width: 250px !important;
  max-width: 250px !important;
}

/* Update the width for first column in cells */
.translation-notification-cell:first-child {
  min-width: 150px !important;
  max-width: 150px !important;
}

/* Date column width */
.translation-notification-cell:nth-child(4) {
  min-width: 120px !important;
  max-width: 120px !important;
}

/* Add these new styles for checkbox alignment */
.translation-notification-cell .MuiCheckbox-root {
  padding: 0 !important;
}

.translation-notification-checkbox-cell {
  text-align: center !important;
  padding: 8px !important;
  vertical-align: middle !important;
  border: 1px solid #E0E0E0 !important;
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  padding: 0 !important;
  text-align: center !important;
}

.translation-notification-checkbox-wrapper {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
}

.translation-notification-truncate {
  max-width: 100% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  cursor: pointer !important;
  padding-right: 8px !important;
}

.translation-notification-button {
  background-color: #112A63 !important;
  border-radius: 12px !important;
  padding-left: 32px !important;
  padding-right: 32px !important;
  width: 257px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  margin-bottom: 40px !important; /* Changed from 20px to 40px */
}

.translation-notification-button:hover {
  background-color: #112A63 !important;
}

.translation-notification-button:disabled {
  background-color: #112A63 !important;
  opacity: 0.7 !important;
}

.translation-notification-tooltip {
  max-width: 500px !important;
  font-size: 14px !important;
  background-color: #333333 !important;
  /* Light grey background */
  color: #F5F5F5 !important;
  /* Dark grey, almost black text */
  padding: 8px 12px !important;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1) !important;
  /* Optional: adds subtle shadow */
}

/* Add this to style the tooltip arrow */
.translation-notification-tooltip .MuiTooltip-arrow {
  color: #F5F5F5 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/TranslationNotification/TranslationNotification.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB,EAAE,sDAAsD;EAC3E,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,yCAAyC;AACxE;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,2BAA2B,EAAE,yDAAyD;AACxF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,oDAAoD;EACpD,yBAAyB;EACzB,uCAAuC,EAAE,+CAA+C;EACxF,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B,EAAE,sDAAsD;AACxF;;AAEA,kCAAkC;AAClC;EACE,wDAAwD;EACxD,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,uCAAuC,EAAE,8BAA8B;AACzE;;AAEA,qDAAqD;AACrD;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB,EAAE,sCAAsC;AAC/D;;AAEA,uBAAuB;AACvB;EACE,8BAA8B,EAAE,uCAAuC;AACzE;;AAEA,2BAA2B;AAC3B;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;;EAEE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;;EAEE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,oCAAoC;EACpC,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B,EAAE,8BAA8B;AAChE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,qDAAqD;EACrD,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B","sourcesContent":[".translation-notification-container {\n  padding: 24px;\n  margin-bottom: 80px; /* Increased to accommodate 40px spacing from footer */\n  margin-top: -35px;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 224px); /* Adjusted for increased bottom margin */\n}\n\n.translation-notification-title {\n  margin-bottom: 16px;\n  color: #666;\n  font-family: 'Montserrat';\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 150%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n}\n\n/* Input container spacing */\n.translation-notification-inputs {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  margin-top: 24px;\n}\n\n/* Base input styles */\n.translation-notification-input {\n  background-color: white;\n  min-width: 240px !important; /* Increased minimum width to accommodate longer labels */\n}\n\n/* Input field styling */\n.translation-notification-input .MuiOutlinedInput-root {\n  border-radius: 8px;\n  height: 56px !important;\n}\n\n/* Label default position with adjusted space for calendar icon */\n.translation-notification-input .MuiInputLabel-root {\n  transform: translate(14px, 16px) scale(1) !important;\n  line-height: 1 !important;\n  max-width: calc(100% - 40px) !important; /* Reduced width to accommodate calendar icon */\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  padding-right: 32px !important; /* Add padding to prevent overlap with calendar icon */\n}\n\n/* Label focused/filled position */\n.translation-notification-input .MuiInputLabel-shrink {\n  transform: translate(14px, -12px) scale(0.75) !important;\n  background-color: white !important;\n  padding: 0 8px !important;\n  margin-top: 4px !important;\n  max-width: calc(133% - 40px) !important; /* Adjusted for shrunk state */\n}\n\n/* Calendar icon positioning with increased spacing */\n.translation-notification-input .MuiInputAdornment-root {\n  margin-right: 12px !important;\n  position: absolute !important;\n  right: 0 !important;\n  z-index: 1 !important; /* Ensure calendar icon stays on top */\n}\n\n/* Input text spacing */\n.translation-notification-input .MuiOutlinedInput-input {\n  padding-right: 40px !important; /* Adjusted padding for calendar icon */\n}\n\n/* Table container styles */\n.translation-notification-table {\n  max-height: calc(100vh - 400px) !important;\n  overflow: auto !important;\n  position: relative !important;\n  border: 1px solid #E0E0E0;\n}\n\n/* Fix header position */\n.translation-notification-header {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1 !important;\n  background-color: #112A63 !important;\n}\n\n.translation-notification-header-cell {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1 !important;\n  background-color: #112A63 !important;\n  color: white !important;\n  padding: 8px !important;\n  vertical-align: middle !important;\n  border-right: 1px solid #ffffff !important;\n}\n\n/* Table body styles */\n.translation-notification-table .MuiTableBody-root {\n  position: relative !important;\n}\n\n/* Hide horizontal scrollbar when not needed */\n.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n/* Sticky header styles */\n.translation-notification-table .MuiTableHead-root {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1 !important;\n  background-color: #112A63 !important;\n}\n\n/* Visual separation for the header */\n.translation-notification-header::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: rgba(0, 0, 0, 0.1);\n  z-index: 1099;\n}\n\n/* Ensure table body scrolls properly */\n.translation-notification-table .MuiTableBody-root {\n  position: relative;\n}\n\n/* Scrollbar styling */\n.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  display: block !important;\n}\n\n.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.translation-notification-table .MuiTableContainer-root::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.translation-notification-table .MuiTableCell-root {\n  border: 1px solid #E0E0E0;\n  padding: 12px;\n}\n\n/* Ensure header stays on top */\n.translation-notification-header {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 2 !important;\n  background-color: #112A63 !important;\n}\n\n/* Update header cell styles */\n.translation-notification-header-cell:last-child {\n  border-right: none !important;\n}\n\n.translation-notification-header-cell:nth-child(2),\n.translation-notification-header-cell:nth-child(3) {\n  min-width: 250px !important;\n  max-width: 250px !important;\n}\n\n/* Update the width for first column in header */\n.translation-notification-header-cell:first-child {\n  min-width: 165px !important;\n  max-width: 165px !important;\n}\n\n/* Header checkbox container */\n.translation-notification-header-checkbox-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1px !important;\n  white-space: nowrap !important;\n}\n\n/* Header checkbox styles */\n.translation-notification-header-checkbox {\n  margin: 0;\n  padding: 0 !important;\n}\n\n/* Match row checkbox styling with grey border */\n.translation-notification-header-checkbox .MuiSvgIcon-root {\n  border: 1px solid #E0E0E0 !important;\n  border-radius: 4px !important;\n  width: 16px !important;\n  height: 16px !important;\n  padding: 0 !important;\n  color: white !important;\n  /* Make the unchecked icon white */\n}\n\n.translation-notification-header-checkbox.Mui-checked .MuiSvgIcon-root {\n  background-color: white !important;\n  color: #2196f3 !important;\n}\n\n/* Remove hover and ripple effects */\n.translation-notification-header-checkbox:hover {\n  background-color: transparent !important;\n  outline: none !important;\n}\n\n.translation-notification-header-checkbox .MuiTouchRipple-root {\n  display: none !important;\n}\n\n/* Override any Material-UI default borders */\n.translation-notification-header-checkbox .MuiIconButton-root {\n  border: none !important;\n}\n\n.translation-notification-row {\n  height: 60px;\n}\n\n.translation-notification-row:nth-of-type(even) {\n  background-color: #F8F9FA;\n}\n\n/* Update cell widths and text wrapping */\n.translation-notification-cell {\n  padding: 12px !important;\n  vertical-align: top !important;\n  word-wrap: break-word !important;\n  white-space: normal !important;\n  max-width: 250px !important;\n}\n\n/* Remove truncation for Original Text and Added/Updated Text columns */\n.translation-notification-cell:nth-child(2),\n.translation-notification-cell:nth-child(3) {\n  white-space: pre-wrap !important;\n  min-width: 250px !important;\n  max-width: 250px !important;\n}\n\n/* Keep truncation for other columns */\n.translation-notification-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Remove truncation for specific columns */\n.translation-notification-cell:nth-child(2) .translation-notification-truncate,\n.translation-notification-cell:nth-child(3) .translation-notification-truncate {\n  white-space: pre-wrap !important;\n  word-break: break-word !important;\n}\n\n/* Adjust width for text columns */\n.translation-notification-cell:nth-child(2),\n.translation-notification-cell:nth-child(3) {\n  min-width: 250px !important;\n  max-width: 250px !important;\n}\n\n/* Update the width for first column in cells */\n.translation-notification-cell:first-child {\n  min-width: 150px !important;\n  max-width: 150px !important;\n}\n\n/* Date column width */\n.translation-notification-cell:nth-child(4) {\n  min-width: 120px !important;\n  max-width: 120px !important;\n}\n\n/* Add these new styles for checkbox alignment */\n.translation-notification-cell .MuiCheckbox-root {\n  padding: 0 !important;\n}\n\n.translation-notification-checkbox-cell {\n  text-align: center !important;\n  padding: 8px !important;\n  vertical-align: middle !important;\n  border: 1px solid #E0E0E0 !important;\n  width: 80px !important;\n  min-width: 80px !important;\n  max-width: 80px !important;\n  padding: 0 !important;\n  text-align: center !important;\n}\n\n.translation-notification-checkbox-wrapper {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  height: 100% !important;\n}\n\n.translation-notification-truncate {\n  max-width: 100% !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  cursor: pointer !important;\n  padding-right: 8px !important;\n}\n\n.translation-notification-button {\n  background-color: #112A63 !important;\n  border-radius: 12px !important;\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n  width: 257px !important;\n  height: 40px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  margin-bottom: 40px !important; /* Changed from 20px to 40px */\n}\n\n.translation-notification-button:hover {\n  background-color: #112A63 !important;\n}\n\n.translation-notification-button:disabled {\n  background-color: #112A63 !important;\n  opacity: 0.7 !important;\n}\n\n.translation-notification-tooltip {\n  max-width: 500px !important;\n  font-size: 14px !important;\n  background-color: #333333 !important;\n  /* Light grey background */\n  color: #F5F5F5 !important;\n  /* Dark grey, almost black text */\n  padding: 8px 12px !important;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1) !important;\n  /* Optional: adds subtle shadow */\n}\n\n/* Add this to style the tooltip arrow */\n.translation-notification-tooltip .MuiTooltip-arrow {\n  color: #F5F5F5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
